import {FilterBase} from './filter-base.js';

/**
 * Dropdown filter component.
 * Provides a select dropdown for choosing from predefined options.
 * @class
 * @extends {FilterBase}
 */
class FilterDropdown extends FilterBase {
    /**
     * Initialize the dropdown filter component.
     * @constructor
     */
    constructor() {
        super();
        /** @type {HTMLSelectElement|null} The select dropdown element */
        this.selectElement = null;
    }

    /**
     * Renders the dropdown filter component.
     * Creates a select element with options from the filter configuration.
     */
    render() {
        super.render(); // Call base render to clear content

        if (!this.filterData || !this.filterData.conf || !this.filterData.conf.choices) {
            console.warn('DropdownFilter: Missing configuration data (conf.choices).', this.filterData);
            // Optionally display an error message within the component
            const errorMsg = document.createElement('span');
            errorMsg.textContent = ' [Configuration Error]';
            errorMsg.style.color = 'red';
            this.appendChild(errorMsg);
            return;
        }

        // Add the select element specific to this filter type
        this.selectElement = document.createElement('select');
        this.selectElement.id = `filter-input-${this.filterData.name}`; // For label association
        this.selectElement.name = this.filterData.name;

        // Populate options from filterData.conf.choices
        const choices = this.filterData.conf.choices;
        for (const value in choices) {
            if (Object.hasOwnProperty.call(choices, value)) {
                const option = document.createElement('option');
                option.value = value;
                option.textContent = choices[value]; // Use the descriptive text from choices
                this.selectElement.appendChild(option);
            }
        }

        this.appendChild(this.selectElement);

        // Default to last option and emit change event
        const opts = this.selectElement.options;
        if (opts.length) {
            this.selectElement.value = opts[opts.length - 1].value;
            window.setTimeout(() => {
                    this.selectElement.dispatchEvent(new Event('change', {bubbles: true}))
                },
                100
            ); // Delay to ensure the event is captured
        }
    }

    /**
     * Gets the current value of the select dropdown.
     * @returns {string|null} The current selected value or null if no select exists
     */
    getValue() {
        return this.selectElement ? this.selectElement.value : null;
    }
}

customElements.define('filter-dropdown', FilterDropdown);
